import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Select } from '@/components/Form/Select';

import { MinorAddressFormType } from '@/constants/minor';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs';

type MinorResidenceSelectProps = {
  disabled: boolean;
};

export function MinorResidenceSelect({
  disabled,
}: Readonly<MinorResidenceSelectProps>) {
  const { t } = useTranslate();
  const { control } = useFormContext<MinorAddressFormType>();
  const { residenceOptions } = useAppSelector(selectConfigsState);

  const translatedResidenceOptions = useMemo(
    () =>
      (residenceOptions || []).map(residenceType => ({
        value: residenceType.value,
        text: residenceType.i18nKey ? t(residenceType.i18nKey) : '',
      })),
    [residenceOptions, t],
  );

  if (!residenceOptions) {
    return null;
  }

  return (
    <Controller
      name="residence"
      control={control}
      render={({ field, fieldState }) => (
        <Select
          {...field}
          control={control}
          options={translatedResidenceOptions}
          label={t('createNewAccount.addressPage.form.residence.label')}
          fullWidth
          disabled={disabled}
          placeholder={t(
            'createNewAccount.addressPage.form.residence.placeHolder',
          )}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      )}
    />
  );
}
